import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   h1 : {
        fontSize : {xs : '32px', lg : '60px'},
        fontWeight : 'bold',
        letterSpacing: '1px',
        lineHeight : '100%'
   },
   h2 : {
        fontSize : {xs : '16px', lg : '24px'},
        fontWeight : 'bold'
    },
    h3 : {
        fontSize : {xs : '24px', lg : '40px'},
        fontWeight : 'bold'
    },
   h5 : {
       fontSize : {xs : '16px', lg : '24px'},
       fontWeight : 'regular'
   },
   subheading : {
       fontSize : {lg : '18px'},
       fontWeight : 'bold',
   },
   subheadingDescription : {
       fontSize : {lg : '16px'},
       fontWeight : 'regular'
   },
   subTimeDate : {
       fontSize : {lg : '14px'},
       fontWeight : 'regular'
   },
   button : {
       padding : '10px 24px',
       borderRadius : '25px',
       fontSize: "16px",
   }
}

const styleSlice = createSlice({
    name : 'styleValues',
    initialState,

    }
)

export const {} = styleSlice.actions

export default styleSlice.reducer